// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 840) return "static/chunks/840.16e9b410381b8485.js";
	if (chunkId === 2655) return "static/chunks/2655.84b0773b8b78e1e2.js";
	if (chunkId === 6213) return "static/chunks/6213.de9c802704f5af32.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"2944":"e228dc6f5da3e662","5944":"686ae96d8f802cef","6709":"5437d81ac0ec35be","8087":"b6b741b016d9675a","8137":"6fd482a25aa364f2","8173":"8807e1df8174f1e1"}[chunkId] + ".js";
};